<!--
 * 供应商准入-评估反馈
-->
<template>
  <div style="background-color: #fff;">
    <div class="wrapper">
      <div v-if="isShowBread" style="padding-top: 10px">
        <base-bread-crumb
          :currBreadCrumb="currBreadCrumb"
          :isShowPortal="false"
        ></base-bread-crumb>
      </div>
      <div class="navBox">
        <div class="navBox-head">
          信用评价
        </div>
        <div class="navBox-content">
          <!-- <div
            class="detail-info-el-Label detail-info-type"
            v-if="baseInfo.reviewStatus && baseInfo.reviewStatus != ''"
          >
            <el-label
              v-if="baseInfo.reviewStatus == 1 || baseInfo.reviewStatus == 5"
              :type="approvingType[5]"
            ></el-label>
            <img
              v-else
              style="height: 116px;"
              src="../../../basa/assets/images/pinggu.png"
              alt=""
            />
          </div>
          <div class="one" style="margin-bottom: 15px;">
            <div class="reviewStatus">
              审核状态
            </div>
            <div class="statusContent">
              <div class="statusContentLeft">
                <span>提交日期：2023-01-23</span>
                <span
                  style="
                    border-left: 1px solid #999999;
                    padding-left: 7px;
                    margin-left: 7px;
                  "
                  >申请编号：AP-20230123003</span
                >
              </div>
              <div class="statusContentRight">
                <span style="color: #33853A;margin-right: 10px;">审批通过</span
                ><span style="margin-right: 10px;">2023-01-23 13:45:32</span>
              </div>
            </div>
          </div>
          <div class="tow" style="margin-bottom: 15px;">
            <div class="reviewStatus">
              审核进度
              <div class="reviewStatusTitle">自动审核，预计3-5分钟</div>
            </div>
            <div class="progressContent">
              <div class="progress">
                <el-progress
                  :percentage="50"
                  :stroke-width="16"
                  :show-text="false"
                  color="#00C471"
                ></el-progress>
              </div>
            </div>
          </div>
          <div class="three" style="padding-bottom: 28px;">
            <div class="reviewStatus">
              审核详情
              <div class="customBtn">
                <button class="custom-button" @click="handleFeedbackRecord">
                  <i class="el-icon-chat-line-round"></i> 反馈记录
                </button>
                <button class="custom-button" @click="handleApplyFeedback">
                  <i class="el-icon-chat-line-round"></i> 申请反馈
                </button>
                <button class="custom-button" @click="handleDownloadReport">
                  <i class="el-icon-download"></i> 下载评价报告
                </button>
              </div>
            </div>
            <div class="detailContent">
              <div class="detailContentTop">
                <div class="left">
                  <p class="leftTop">高风险</p>
                  <p class="leftBottom">低风险</p>
                </div>
                <div class="center">
                  <div class="sanjiao">
                    <div
                      :class="
                        riskStatus == '1' ? 'sanjiao1 sanjiaoTop' : 'sanjiao1'
                      "
                    ></div>
                    <div
                      :class="
                        riskStatus == '2'
                          ? 'sanjiao2 sanjiaoCenter'
                          : 'sanjiao2'
                      "
                    ></div>
                    <div
                      :class="
                        riskStatus == '3'
                          ? 'sanjiao3 sanjiaoBottom'
                          : 'sanjiao3'
                      "
                    ></div>
                  </div>
                </div>
                <div class="right">
                  <p class="rightTop">中风险 55分</p>
                  <p class="rightCenter">
                    ·经系统模型综合分析判断，该企业当前风险等级处于中等水平，需进一步考核供应商实际经营情况。
                  </p>
                  <p class="rightBottom">
                    ·风险等级评分为:低风险、中风险、高风险
                  </p>
                </div>
              </div>
              <div class="detailContentTable">
                <div class="ccui-multifunctional-table-wrapper">
                  <el-table
                    :data="tableData"
                    :fit="true"
                    border
                    class="ccui-multifunctional-table"
                    :header-cell-style="{ backgroundColor: '#EFF3FA' }"
                  >
                    <template v-for="(table, index) in dataJs.ipAlertList">
                      <el-table-column
                        :fixed="table.fixed || false"
                        :key="index"
                        :type="table.type"
                        :label="table.label"
                        :min-width="table.width"
                        :prop="table.prop"
                        :align="table.align || 'left'"
                        :header-align="table.headerAlign || 'left'"
                        :filters="table.filters"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                    </template>
                  </el-table>
                </div>
              </div>
            </div>
          </div> -->

          <div class="three" style="padding-bottom: 22px;">
            <!-- <div class="reviewStatus">
              信用评分构成
              <div class="customBtn">
                <button class="custom-button" @click="handleFeedbackRecord">
                  <i class="el-icon-chat-line-round"></i> 反馈记录
                </button>
                <button class="custom-button" @click="handleApplyFeedback">
                  <i class="el-icon-chat-line-round"></i> 申请反馈
                </button> -->
            <!-- <button class="custom-button" @click="handleDownloadReport">
                  <i class="el-icon-download"></i> 下载评价报告
                </button> -->
            <!-- </div>
            </div> -->

            <div class="threeContent">
              <!-- <div class="echarts">
                <div
                  class=""
                  ref="ringChart"
                  style="width: 280px; height: 161px;"
                ></div>
              </div> -->
              <div class="pfgc">
                <div class="pfgcImg">
                  <img src="../../../basa/assets/images/xinyong.png" alt="" />
                </div>
                <div class="pingfen">
                  <div class="pingfenTop" v-if="baseInfo1.score">
                    {{ baseInfo1.score }}
                  </div>
                  <div class="pingfenTop" v-else>暂无数据</div>
                  <div class="pingfenCenter">信用评分</div>
                </div>
                <div class="tongbi">
                  <div class="tongbiTop">
                    诚信为本，合作共赢
                  </div>
                  <!-- <div class="tongbiCenter">满分100分，排名前10%</div> -->
                </div>
                <div class="pingfenTime">
                  <div class="pingfenTimeTop" v-if="baseInfo1.endTime">
                    {{ baseInfo1.endTime }}
                  </div>
                  <div class="pingfenTimeTop" v-else>暂无数据</div>
                  <div class="pingfenTimeBottom">本次评估日期</div>
                </div>
              </div>
            </div>
          </div>

          <div class="three" style="padding-bottom: 183px;">
            <div class="reviewStatus">
              评分详情
            </div>

            <div class="threeContent">
              <div class="ccui-multifunctional-table-wrapper">
                <el-table
                  ref="selectConTable"
                  :data="tableData"
                  :fit="true"
                  :cell-style="cellStyle"
                  @cell-click="cellClick"
                  :header-cell-style="headerCellStyle"
                >
                  <!-- 序号 -->
                  <el-table-column
                    :show-overflow-tooltip="true"
                    label="序号"
                    type="index"
                    min-width="20%"
                    height="36px"
                  />
                  <template v-for="(table, index) in tableTheadOptions">
                    <el-table-column
                      :fixed="table.fixed || false"
                      :key="index"
                      :label="table.label"
                      :align="table.align || 'left'"
                      :header-align="table.headerAlign || 'left'"
                      :width="table.width"
                      :min-width="table.minWidth"
                      :prop="table.prop"
                      :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                  </template>
                  <!-- <el-table-column label="操作" fixed="right" width="100">
                    <template slot-scope="{ row }">
                      <el-button type="text" @click="downLoad(row)"
                        >下载</el-button
                      >
                    </template>
                  </el-table-column> -->
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 反馈记录 -->
    <feedbackManagement
      ref="feedbackManagement"
      :supCode="supCode"
      :type="'creditEvaluation'"
    />
    <!-- 申请反馈 -->
    <AppealFeedbackDialog
      ref="appealFeedbackDialog"
      :supCode="supCode"
      :type="'creditEvaluation'"
    />
    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      height="90vh"
      class="custom-dialog"
    >
      <iframe
        :src="reportUrl"
        frameborder="0"
        height="100%"
        width="100%"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >关闭</el-button
        >
        <!--<el-button size="mini" type="primary-font-mini" @click="addRoleInfo()"-->
        <!--&gt;提交</el-button-->
        <!--&gt;-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBatchScoreResult, download } from "../api";
import dataJs from "../js";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import feedbackManagement from "./feedbackManagement.vue";
import AppealFeedbackDialog from "./appealFeedbackDialog.vue";
// import * as echarts from "echarts";
import Cookies from "js-cookie";

export default {
  components: {
    baseBreadCrumb,
    feedbackManagement,
    AppealFeedbackDialog
  },
  data() {
    return {
      dataJs,
      active: 0,
      baseInfo: {
        riskLevel: ""
      }, // 详情信息
      approvingType: {
        0: "pending", //待审批
        1: "approving", // 审批中
        2: "withdrawn", // 已撤回
        3: "approvaled", // 审批通过
        4: "sendback", // 已退回
        5: "unapproval" // 审批不通过
      },
      currBreadCrumb: [
        { title: "采购公告", path: "/procurementNotice" },
        { title: "公开采购公告", path: "/procurementNotice" },
        { title: sessionStorage.getItem("searchName") }
      ],
      dialogVisible: false,
      reportUrl: "",
      supCode: Cookies.get("sup_code") || this.$route.query.supCode,
      isShowBread: false,
      riskStatus: "2", // 风险等级: 1高风险 2中风险 3低风险
      tableData: [],
      baseInfo1: {
        score: "",
        endTime: ""
      },
      tableTheadOptions: [
        {
          label: "附件名称",
          prop: "reportUrl"
        }
      ],
      supplyConc: [
        {
          extData: null,
          name: "综合实力",
          value: 80
        },
        {
          extData: null,
          name: "合规经营",
          value: 80
        },
        {
          extData: null,
          name: "财务能力",
          value: 79
        },
        {
          extData: null,
          name: "合作能力",
          value: 56
        },
        {
          extData: null,
          name: "发展潜力",
          value: 98
        }
      ]
    };
  },
  watch: {},
  mounted() {
    if (this.$route.query.type == 4) {
      this.currBreadCrumb[1].title = "中标结果公示";
      this.currBreadCrumb[1].path = "/procurementNotice?type=4";
    }
  },
  activated() {
    this.getDetail();
  },
  deactivated() {},
  methods: {
    getDetail() {
      // let obj = {
      //   supCode: this.supCode
      // };
      // qrySupReviewDetail(obj).then(res => {
      //   if (res.data.code == "0") {
      //     this.baseInfo = res.data.data.reviewDetail;
      //     this.baseInfo.submitTime = this.baseInfo.submitTime
      //       ? this.baseInfo.submitTime.subStr(0, 10)
      //       : "";
      //   }
      // });
      getBatchScoreResult({
        supCode: this.supCode,
        pageSize: 1,
        pageNo: 1
      }).then(res => {
        if (res.data.code == "0") {
          this.tableData = res.data.data.rows;
          this.baseInfo1 = {
            score: this.tableData[0].score,
            endTime: this.tableData[0].endTime
              ? this.tableData[0].endTime.substr(0, 10)
              : ""
          };
        }
        // if (!this.tableData.length) {
        //   this.tableData = [
        //     {
        //       batchId: "313",
        //       batchIds: [],
        //       createTime: "2025-04-26 02:00:34",
        //       endTime: "2025-04-25 10:15:25",
        //       endTimeStr: "2025-04-25 10:15:25",
        //       id: "2688948303288586249",
        //       isNewest: 0,
        //       limit: 0,
        //       maindataSupCode: "",
        //       order: "",
        //       recordId: 0,
        //       reportUrl: "大连鑫丰船舶燃料供应有限公司_10051_1505626.pdf",
        //       riskLevel: 0,
        //       score: 68.65,
        //       scoreStr: "68.65",
        //       smBaseScore: "50.00000000",
        //       smId: "10051",
        //       smName: "五期-供应商信用评价模型-贸易商-all",
        //       smType: "1",
        //       smrrId: "",
        //       smsrId: "",
        //       ssCreditCode: "91210200792020295H",
        //       ssId: 0,
        //       ssName: "大连鑫丰船舶燃料供应有限公司",
        //       startTime: "2025-04-25 10:15:19",
        //       supCode: "2001200100000006380",
        //       supCodes: [],
        //       supId: 0,
        //       supName: "大连鑫丰船舶燃料供应有限公司",
        //       supplierCode: "",
        //       updateTime: "2025-04-26 02:00:34"
        //     }
        //   ];
        // }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (["reportUrl"].includes(column?.property)) {
        return { color: "#0089EF", cursor: "pointer" };
      }
    },
    cellClick(row, column, columnIndex) {
      if (column.property == "reportUrl") {
        this.downLoad(row);
      }
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {},
    // 获取环形图数据
    // getRingChart(supplyConc) {
    //   const myChart = echarts.init(this.$refs.ringChart);
    //   myChart.setOption({
    //     tooltip: {
    //       trigger: "item",
    //       formatter: function(params) {
    //         // params 是一个包含当前数据信息的数组
    //         console.log(params);
    //         let result = "";
    //         // params.forEach(function (item) {
    //         //   const seriesName = item.seriesName; // 系列名称
    //         //   const value = item.value; // 数据值
    //         result = `${params.data.name}: ${params.data.value}<br/>`;
    //         // });
    //         return result;
    //       }
    //     },
    //     legend: {
    //       top: "15%", // 垂直居中，可根据需要调整
    //       left: "10px", // 距离左侧10px，可根据需要调整
    //       orient: "vertical", // 可选：将图例设置为垂直排列，更适合左侧显示
    //       itemWidth: 18, // 色块宽度
    //       itemHeight: 12 // 色块高度
    //     },
    //     series: [
    //       {
    //         name: "Access From",
    //         type: "pie",
    //         radius: ["40%", "70%"],
    //         center: ["70%", "50%"],
    //         label: {
    //           show: false,
    //           position: "center",
    //           color: "#4A4A4A" // 设置字体颜色为红色
    //         },
    //         data: supplyConc,
    //         itemStyle: {
    //           normal: {
    //             color: function(params) {
    //               // 定制颜色，params.dataIndex为当前数据项的索引
    //               var colorList = [
    //                 "#5087EC",
    //                 "#F2BD42",
    //                 "#33EBFF",
    //                 "#EE5A5A",
    //                 "#70D393"
    //               ];
    //               return colorList[params.dataIndex % colorList.length];
    //             }
    //           }
    //         }
    //       }
    //     ]
    //   });
    // },
    // 反馈记录
    handleFeedbackRecord() {
      this.$refs["feedbackManagement"].dialogVisible = true;
    },
    handleApplyFeedback() {
      this.$refs["appealFeedbackDialog"].dialogVisible = true;
    },
    handleDownloadReport() {
      console.log("下载评价报告按钮被点击");
    },
    // 下载
    downLoad(row) {
      download({
        reportName: row.reportUrl,
        purSupFlag: "pur",
        // reportName:'上海智信专利代理有限公司_10052_866575.pdf',
        isShowLoading: true
      }).then(res => {
        this.dialogVisible = true;
        const blob = new Blob([res.data], { type: res.data.type });
        const url = window.URL.createObjectURL(blob);
        this.reportUrl = url;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.navBox {
  margin-top: 20px;
  line-height: 56px;
  align-items: center;
}
.navBox-head {
  padding-left: 8px;
  height: 59px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #4a4a4a;
  line-height: 59px;
  text-align: left;
  font-style: normal;
  border-bottom: 1px solid #e7e7e7;
}
.navBox-content {
  position: relative;
  padding-left: 12px;
}
// 审核状态
.reviewStatus {
  position: relative;
  margin-top: 16px;
  padding-left: 10px;
  height: 25px;
  line-height: 25px;
  border-left: 4px solid #3860f4;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #4a4a4a;
  text-align: left;
  font-style: normal;
}
.statusContent {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}
.statusContentLeft {
  margin-left: 25px;
  width: 350px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.statusContentRight {
  width: 212px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  color: #999999;
}
// 审核进度
.progressContent {
  width: 801px;
  height: 16px;
  background: #ededed;
  border-radius: 8px;
}
.reviewStatusTitle {
  position: absolute;
  top: 2px;
  left: 84px;
  width: 152px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
// 审核详情
.detailContentTop {
  margin-top: 8px;
  margin-left: 19px;
  display: flex;
  height: 235px;
  background: #fafcff;
}
.left {
  position: relative;
  margin: 13px 164px 22px 23px;
  width: 12px;
  height: 200px;
  background: linear-gradient(180deg, #eb4948 0%, #ffc93e 48%, #19bc6b 100%);
  border-radius: 6px;
}
.leftTop {
  position: absolute;
  top: 0;
  left: 18px;
  width: 36px;
  height: 17px;
  font-family: PingFangTC, PingFangTC;
  font-weight: 400;
  font-size: 12px;
  color: #4a4a4a;
  line-height: 17px;
  text-align: left;
  font-style: normal;
}
.leftBottom {
  position: absolute;
  bottom: 0;
  left: 18px;
  width: 36px;
  height: 17px;
  font-family: PingFangTC, PingFangTC;
  font-weight: 400;
  font-size: 12px;
  color: #4a4a4a;
  line-height: 17px;
  text-align: left;
  font-style: normal;
}
.center {
  margin-top: 13px;
  margin-right: 115px;
  width: 200px;
  height: 200px;
  text-align: center;
}
.sanjiao {
  position: relative;
  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-bottom: 200px solid #fafcff; /* 这里的颜色可根据图片调整为对应的灰色 */
  // #FAFCFF
}
.sanjiao1 {
  // margin: 0 auto;
  // width: 38px;
  // height: 38px;
  // margin-left: 81px;
  // background: #E5E5E5;
  position: absolute;
  top: 0;
  left: -32px;
  width: 0;
  height: 0;
  border-left: 32px solid transparent;
  border-right: 32px solid transparent;
  border-bottom: 62px solid #e5e5e5; /* 这里的颜色可根据图片调整为对应的灰色 */
}

.sanjiao2 {
  // margin: 10px auto;
  // width: 79px;
  // height: 36px;
  // margin: 5px 0 0 61px;

  position: absolute;
  top: 82px;
  left: -64px;
  width: 84px;
  height: 0;
  border-left: 22px solid transparent;
  border-right: 22px solid transparent;
  border-bottom: 44px solid #e5e5e5; /* 这里的颜色可根据图片调整为对应的灰色 */
}

.sanjiao3 {
  // margin: 0 auto;
  // width: 120px;
  // height: 36px;
  // margin: 5px 0 0 40px;

  position: absolute;
  top: 146px;
  left: -101px;
  width: 148px;
  height: 0;
  border-left: 27px solid transparent;
  border-right: 27px solid transparent;
  border-bottom: 54px solid #e5e5e5; /* 这里的颜色可根据图片调整为对应的灰色 */
}
.sanjiaoTop {
  border-bottom: 62px solid #eb4948; /* 这里的颜色可根据图片调整为对应的颜色 */
}
.sanjiaoCenter {
  border-bottom: 44px solid #f8c83f; /* 这里的颜色可根据图片调整为对应的灰色 */
}
.sanjiaoBottom {
  border-bottom: 54px solid #19bc6b; /* 这里的颜色可根据图片调整为对应的灰色 */
}
.right {
  width: 552px;
}
.rightTop {
  margin-top: 22px;
  width: 89px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #f8a03f;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.rightCenter {
  margin: 16px 0 10px 0;
  width: 552px;
  height: 44px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.rightBottom {
  width: 488px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
// 审核详情-table
.detailContentTable {
  margin-top: 10px;
  margin-left: 19px;
  padding-right: 110px;
}
.customBtn {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
}
.custom-button {
  width: 100px;
  height: 28px;
  background: linear-gradient(180deg, #6b98ff 0%, #4672ff 100%);
  border-radius: 4px;
  // background-color: #409eff;
  // color: white;
  // border: none;
  // padding: 8px 16px;
  // border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
  font-family: PingFangTC, PingFangTC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  border: none;
  line-height: 28px;
}
.custom-button:nth-last-child(1) {
  width: 126px;
}

.detail-info-type {
  position: absolute;
  top: -8px;
  right: 90px;
}

.threeContent {
  display: flex;
}
// 评分构成
.pfgc {
  display: flex;
  position: relative;
  width: 100%;
  margin-left: 19px;
  margin-top: 23px;
  height: 120px;
  background: #eef6f7;
}
.pfgcImg {
  width: 93.29px;
  height: 113.73px;
  margin-left: 4px;
}
.echarts {
  margin-left: 140px;
}
.pingfen {
  position: relative;
  left: -8px;
  // width: 52px;
  height: 100%;
  .pingfenTop {
    // width: 45px;
    height: 48px;
    margin-top: 28px;
    margin-left: 4px;
    margin-bottom: 8px;
    font-family: DOUYINSANSBOLD, DOUYINSANSBOLD;
    font-weight: normal;
    font-size: 40px;
    color: #006eff;
    line-height: 48px;
    text-align: right;
    font-style: normal;
  }
  .pingfenCenter {
    height: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #7c7c7c;
    line-height: 18px;
    text-align: center;
    font-style: normal;
  }
}
.tongbi {
  margin-left: 93px;
  margin-top: 38px;
  // width: 144px;
  .tongbiTop {
    margin-bottom: 18px;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #22b478;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
  .tongbiCenter {
    height: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #7a7a7a;
    line-height: 18px;
    text-align: right;
    font-style: normal;
  }
}
.pingfenTime {
  position: absolute;
  top: 42px;
  right: 36px;
  // width: 95px;
  .pingfenTimeTop {
    height: 21px;
    margin-bottom: 21px;
    font-family: DOUYINSANSBOLD, DOUYINSANSBOLD;
    font-weight: normal;
    font-size: 18px;
    color: #006eff;
    line-height: 21px;
    font-style: normal;
  }
  .pingfenTimeBottom {
    height: 18px;
    margin-left: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #858686;
    line-height: 18px;
    font-style: normal;
  }
}
.ccui-multifunctional-table-wrapper {
  margin-top: 20px;
  margin-left: 15px;
}

.ccui-multifunctional-table-wrapper /deep/ .el-table {
  margin-bottom: 20px;
  width: 100%;
  border: 1px solid #edf2fc;
  border-bottom: none;
  td,
  th.is-leaf {
    border-right: 1px solid #edf2fc;
  }
}

// 设置弹框样式
::v-deep .custom-dialog .el-dialog {
  display: flex;
  flex-direction: column;
  height: 90vh; /* 设置对话框高度 */
}

::v-deep .custom-dialog .el-dialog__body {
  flex: 1;
  padding: 10px 20px;
  overflow: hidden !important;
  max-height: 85vh !important; /* 设置对话框高度 */
}

.dialog-iframe {
  width: 100%;
  height: 100%;
  border: none;
  min-height: 500px; /* 设置最小高度，防止高度塌陷 */
}
</style>
